// extracted by css-extract-rspack-plugin
export default {"errorMessage":"src-widgets-SchemaSelector-module__errorMessage-EY3y2b"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"errorMessage\":\"src-widgets-SchemaSelector-module__errorMessage-EY3y2b\"}";
        // 1793732400032
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  